import NewsForm from './NewsForm';

export default NewsForm;
